var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68945 5.375L9.85352 2.24023C10.0293 2.06445 10.0293 1.74219 9.85352 1.56641L9.12109 0.833984C8.94531 0.658203 8.62305 0.658203 8.44727 0.833984L5.3125 3.99805L2.14844 0.833984C1.97266 0.658203 1.65039 0.658203 1.47461 0.833984L0.742188 1.56641C0.566406 1.74219 0.566406 2.06445 0.742188 2.24023L3.90625 5.375L0.742188 8.53906C0.566406 8.71484 0.566406 9.03711 0.742188 9.21289L1.47461 9.94531C1.65039 10.1211 1.97266 10.1211 2.14844 9.94531L5.3125 6.78125L8.44727 9.94531C8.62305 10.1211 8.94531 10.1211 9.12109 9.94531L9.85352 9.21289C10.0293 9.03711 10.0293 8.71484 9.85352 8.53906L6.68945 5.375Z",
    fill: "#FD6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.fcaff79c2ef4993cd0c65629129c43e9.svg";
export { ForwardRef as ReactComponent };